import { create } from "zustand";

const useSaveBarStore = create((set) => ({
  isVisible: false,
  onSave: null,
  onDiscard: null,
  setState: ({ isVisible, onSave, onDiscard }) =>
    set({
      isVisible,
      onSave,
      onDiscard,
    }),
  showSaveBar: () => set({ isVisible: true }),
  hideSaveBar: () => set({ isVisible: false }),
}));

export default useSaveBarStore;